export default "__VITE_ASSET__IhIogBbq__"